import { render, staticRenderFns } from "./addFeeCombo.vue?vue&type=template&id=60b876a0&scoped=true"
import script from "./addFeeCombo.vue?vue&type=script&lang=js"
export * from "./addFeeCombo.vue?vue&type=script&lang=js"
import style0 from "./addFeeCombo.vue?vue&type=style&index=0&id=60b876a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b876a0",
  null
  
)

export default component.exports